/* =========================================================
   COASTAL ACCORDION — v1
   Transforme chaque option Globo de type "image-swatches"
   en champ compact : une barre affichant la valeur choisie,
   qui déploie sa grille de vignettes au survol (souris) ou
   au tap (tactile). Un seul champ ouvert à la fois.

   Les options radio / select ne sont JAMAIS touchées.
   Le tooltip de globo.tooltip.js continue de fonctionner
   tel quel par-dessus.

   Contrainte structurante : Globo re-rend son DOM à chaque
   changement de sélection. Tous les écouteurs sont donc
   délégués au document (aucun nœud volatil n'en porte), et
   toute injection est idempotente.
   ========================================================= */
(function () {
  var FIELD_CLASS   = 'coastal-field';
  var OPEN_CLASS    = 'is-open';
  var ERROR_CLASS   = 'coastal-field--error';
  var TRIGGER_CLASS = 'coastal-field__trigger';
  var VALUE_CLASS   = 'coastal-field__value';

  var CLOSE_DELAY         = 240; // ms — tolérance au trajet de la souris
  var AUTOCLOSE_AFTER_PICK = 400; // ms — mode tap uniquement
  var PLACEHOLDER = 'Select an option';

  // Mêmes seuils que isClickMode() dans globo.tooltip.js.
  // Un seuil différent produirait un état hybride : panneau
  // en mode hover d'un côté, tooltip en mode modale de l'autre.
  var NO_HOVER_MQ = window.matchMedia('(hover: none), (pointer: coarse)');
  var NARROW_MQ   = window.matchMedia('(max-width: 768px)');
  function isTapMode() {
    return NO_HOVER_MQ.matches || NARROW_MQ.matches;
  }

  function closestFrom(node, selector) {
    if (!node || !node.closest) return null;
    return node.closest(selector);
  }

  // ---------- détection du périmètre ----------
  // Globo expose le type dans data-element-id : "image-swatches-1"
  // vs "radio-5" / "select-2". Les radio/select ne matchent ni le
  // test primaire ni le repli : le périmètre est garanti par la
  // structure, pas par une liste d'exclusions à maintenir.
  function isImageSwatchField(el) {
    if (!el || !el.classList || !el.classList.contains('gpo-element')) return false;
    if (el.querySelector('.gpo-swiper-container')) return false; // mode slider Globo : on ne touche pas
    var id = el.getAttribute('data-element-id') || '';
    if (id.indexOf('image-swatches-') === 0) return true;
    return !!el.querySelector('.gpo-swatches.image-swatches img.swatch-image');
  }

  // ---------- libellé de l'option ----------
  // Source d'autorité : window.GPOConfigs, SCOPÉ par option set.
  // GPOConfigs.options contient les ~312 jeux d'options de la
  // boutique et les ids d'élément n'y sont pas uniques
  // ("image-swatches-1" = Material dans l'un, Tubing dans l'autre) :
  // une recherche non scopée renverrait un libellé arbitraire.
  // Cette source est aussi immunisée au bug qui écrase .label-content.
  function readOptionLabel(field) {
    if (field.dataset.coastalLabel) return field.dataset.coastalLabel;

    var app   = closestFrom(field, '.gpo-app');
    var setId = app && app.getAttribute('data-option-set-id');
    var cfg   = window.GPOConfigs && window.GPOConfigs.options && setId
      ? window.GPOConfigs.options[setId]
      : null;
    var id = field.getAttribute('data-element-id');

    if (cfg && id) {
      var groups = cfg.elements || [];
      for (var g = 0; g < groups.length; g++) {
        var els = groups[g].elements || [groups[g]];
        for (var e = 0; e < els.length; e++) {
          if (els[e] && els[e].id === id && els[e].label) {
            field.dataset.coastalLabel = els[e].label;
            return els[e].label;
          }
        }
      }
    }

    var lc = field.querySelector('.gpo-label .label-content');
    return lc ? lc.textContent.trim() : '';
  }

  // Répare .label-content s'il a été écrasé (filet de sécurité :
  // rend le module correct même si le correctif de
  // globo.tooltip.js n'est pas encore déployé sur ce thème).
  function repairLabel(field) {
    var label = readOptionLabel(field);
    if (!label) return;
    var lc = field.querySelector('.gpo-label .label-content');
    if (lc && lc.textContent.trim() !== label) lc.textContent = label;
  }

  // ---------- valeur sélectionnée ----------
  // On LIT .gpo-selected-values, on n'y écrit jamais : Globo y
  // fait innerHTML = ... à chaque change, et y écrire créerait
  // un ping-pong avec le MutationObserver. D'où le <button> dédié.
  function readSelectedText(field) {
    var sv = field.querySelector('.gpo-selected-values.has-value');
    if (sv && sv.textContent.trim()) return sv.textContent.trim();

    var checked = field.querySelector(
      '.gpo-ov-item input[type="radio"]:checked, .gpo-ov-item input[type="checkbox"]:checked'
    );
    if (!checked) return null;

    // Repli indispensable : pour les options dont le libellé
    // contient un guillemet droit, Globo laisse .gpo-selected-values
    // vide. Le titre du tooltip est du texte HTML, donc insensible
    // au défaut d'échappement d'attribut.
    var item = closestFrom(checked, '.gpo-ov-item');
    var t = item && item.querySelector('.gpo-tooltip .gpo-tooltip__title .break-word');
    if (t && t.textContent.trim()) return t.textContent.trim();

    return checked.value || null;
  }

  // ---------- état d'erreur Globo ----------
  // Un champ requis refusé doit s'ouvrir tout seul, sinon le
  // message est invisible dans un panneau fermé et l'ajout au
  // panier bloqué devient inexplicable.
  function hasError(field) {
    if (field.classList.contains('has-error') || field.classList.contains('gpo-error')) return true;
    var msg = field.querySelector('.messages .error, .gpo-message.error, .error-message');
    return !!(msg && msg.offsetParent !== null);
  }

  // ---------- injection idempotente ----------
  function enhanceField(field) {
    field.classList.add(FIELD_CLASS);

    var wrapper = field.querySelector(':scope > .gpo-ov-wrapper');
    if (!wrapper) return;
    if (!wrapper.id) {
      wrapper.id = 'coastal-panel-' + Math.random().toString(36).slice(2, 9);
    }

    var trigger = field.querySelector(':scope > .' + TRIGGER_CLASS);
    if (!trigger) {
      trigger = document.createElement('button');
      trigger.type = 'button'; // IMPÉRATIF : sinon il soumet le formulaire produit
      trigger.className = TRIGGER_CLASS;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', wrapper.id);
      trigger.innerHTML =
        '<span class="' + VALUE_CLASS + '"></span>' +
        '<span class="coastal-field__chevron" aria-hidden="true"></span>';
      // Après .gpo-label et après un éventuel .gpo-helptext,
      // sans hypothèse sur le nombre d'enfants.
      wrapper.parentNode.insertBefore(trigger, wrapper);
    }

    repairLabel(field);
    syncField(field);
  }

  // Chaque écriture DOM est précédée d'un test d'égalité :
  // c'est ce qui empêche le MutationObserver de s'auto-déclencher.
  function syncField(field) {
    var trigger = field.querySelector(':scope > .' + TRIGGER_CLASS);
    if (!trigger) return;

    var valEl = trigger.querySelector('.' + VALUE_CLASS);
    if (!valEl) return;

    var txt  = readSelectedText(field);
    var next = txt || PLACEHOLDER;
    if (valEl.textContent !== next) valEl.textContent = next;

    var empty = txt ? '0' : '1';
    if (valEl.getAttribute('data-empty') !== empty) valEl.setAttribute('data-empty', empty);

    var aria = readOptionLabel(field) + ' : ' + next;
    if (trigger.getAttribute('aria-label') !== aria) trigger.setAttribute('aria-label', aria);

    var open = field.classList.contains(OPEN_CLASS);
    if (trigger.getAttribute('aria-expanded') !== String(open)) {
      trigger.setAttribute('aria-expanded', String(open));
    }

    var err = hasError(field);
    if (err !== field.classList.contains(ERROR_CLASS)) {
      field.classList.toggle(ERROR_CLASS, err);
    }
  }

  // ---------- ouverture / fermeture ----------
  var openField = null;
  var closeTimer = null;
  var pickTimer = null;

  function setOpen(f)   { f.classList.add(OPEN_CLASS);    syncField(f); }
  function setClosed(f) { f.classList.remove(OPEN_CLASS); syncField(f); }

  function openOnly(f) {
    clearTimeout(closeTimer);
    if (openField === f) return;
    // Fermeture immédiate de l'ancien : deux panneaux visibles
    // pendant 240ms serait pire que le trou qu'on cherche à éviter.
    if (openField) setClosed(openField);
    openField = f;
    setOpen(f);
  }

  function scheduleClose(f, delay) {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      if (openField === f) {
        setClosed(f);
        openField = null;
      }
    }, delay == null ? CLOSE_DELAY : delay);
  }

  function closeNow() {
    clearTimeout(closeTimer);
    if (openField) {
      setClosed(openField);
      openField = null;
    }
  }

  // ---------- hover (souris) ----------
  // Un seul écouteur suffit : pointerover bulle. La « zone de
  // survol continue » vient de l'arbre DOM — le panneau est un
  // enfant de .gpo-element, donc y entrer garde le pointeur
  // dans .coastal-field même s'il est hors flux. Aucun calcul
  // géométrique. Seul le gap de 6px est comblé, en CSS, par le
  // ::before du panneau.
  document.addEventListener('pointerover', function (ev) {
    if (isTapMode()) return;
    if (ev.pointerType && ev.pointerType !== 'mouse') return;

    var f = closestFrom(ev.target, '.' + FIELD_CLASS);
    if (f) openOnly(f);
    else if (openField) scheduleClose(openField);
  });

  // Sortie de la fenêtre : pointerover ne se déclenche plus.
  document.documentElement.addEventListener('mouseleave', function () {
    if (openField) scheduleClose(openField);
  });

  // ---------- tap (tactile) + clic sur le déclencheur ----------
  // Phase de bulle, pour laisser passer l'écouteur en CAPTURE de
  // globo.tooltip.js. Séquence sur un tap de vignette :
  // capture tooltip -> Globo coche le radio -> ici on constate
  // qu'on est dans le champ ouvert et on ne fait rien. La modale
  // s'ouvre, le panneau reste dessous.
  document.addEventListener('click', function (ev) {
    var trig = closestFrom(ev.target, '.' + TRIGGER_CLASS);
    if (trig) {
      var f = closestFrom(trig, '.' + FIELD_CLASS);
      if (!f) return;
      if (openField === f) closeNow();
      else openOnly(f);
      return; // type="button" : rien à annuler
    }

    if (!openField) return;
    if (closestFrom(ev.target, '.' + FIELD_CLASS) === openField) return;
    if (closestFrom(ev.target, '.gpo-tooltip, .coastal-tooltip-backdrop')) return;
    closeNow();
  });

  // ---------- synchronisation de la valeur ----------
  document.addEventListener('change', function (ev) {
    var f = closestFrom(ev.target, '.' + FIELD_CLASS);
    if (!f) return;

    // Un tick : notre écouteur document peut se déclencher avant
    // que Globo n'ait écrit .gpo-selected-values (il écoute sur
    // des nœuds plus proches).
    setTimeout(function () { syncField(f); }, 0);

    if (isTapMode()) {
      clearTimeout(pickTimer);
      pickTimer = setTimeout(function () {
        if (document.querySelector('.gpo-tooltip.is-open')) return; // modale ouverte : on ne bouge pas
        if (openField === f) closeNow();
      }, AUTOCLOSE_AFTER_PICK);
    }
    // En mode hover, pas d'auto-fermeture : le pointeur est encore
    // sur le champ, pointerover gère seul.
  });

  // ---------- accessibilité clavier ----------
  document.addEventListener('focusin', function (ev) {
    var f = closestFrom(ev.target, '.' + FIELD_CLASS);
    if (!f) return;
    if (f !== openField && closestFrom(ev.target, '.gpo-ov-wrapper')) openOnly(f);
    if (f === openField) clearTimeout(closeTimer);
  });

  // On ne peut PAS se fier à relatedTarget ici : il vaut null dès que
  // le focus part vers un élément non focusable — ce qui est le cas du
  // <label> d'une vignette. En mode tap (pas de pointerover pour
  // rouvrir), la séquence était :
  //   mousedown sur la vignette -> le déclencheur perd le focus
  //   -> on fermait le panneau -> mouseup atterrit ailleurs
  //   -> AUCUN click n'est émis -> rien ne se coche.
  // C'est ce qui rendait la sélection impossible en mobile.
  // On regarde donc où le focus a réellement atterri, un tick plus tard.
  document.addEventListener('focusout', function () {
    if (!openField) return;
    var f = openField;
    setTimeout(function () {
      if (openField !== f) return;
      var ae = document.activeElement;
      // <body> = on a cliqué un élément non focusable : ce n'est pas
      // une sortie du champ, on garde le panneau ouvert.
      if (!ae || ae === document.body) return;
      if (!ae.closest || ae.closest('.' + FIELD_CLASS) !== f) scheduleClose(f, 0);
    }, 0);
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape' || !openField) return;
    // Priorité explicite : le 1er Échap ferme le tooltip
    // (globo.tooltip.js), le 2e ferme le champ.
    if (document.querySelector('.gpo-tooltip.is-open')) return;
    var t = openField.querySelector('.' + TRIGGER_CLASS);
    closeNow();
    if (t) t.focus();
  });

  // ---------- scan + observation ----------
  function scan(root) {
    (root || document).querySelectorAll('.gpo-element').forEach(function (el) {
      if (!isImageSwatchField(el)) return;
      enhanceField(el);
      if (el.classList.contains(ERROR_CLASS) && openField !== el) openOnly(el);
    });

    // Globo a pu recréer le nœud ouvert : on le détecte plutôt
    // que de garder une référence orpheline.
    if (openField && !document.contains(openField)) openField = null;
  }

  var patching = false;
  var pending  = false;

  // Throttle en setTimeout et NON en requestAnimationFrame :
  // rAF est suspendu dans un onglet d'arrière-plan, or Globo rend
  // ses options de façon asynchrone — une fiche ouverte dans un
  // onglet d'arrière-plan resterait alors en grille dépliée tant
  // qu'on ne l'a pas mise au premier plan. On ne fait ici que des
  // lectures/écritures DOM idempotentes : l'alignement sur la
  // frame n'apporte rien.
  var mo = new MutationObserver(function () {
    if (patching || pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      patching = true;
      try { scan(document); } finally { patching = false; }
    }, 16);
  });

  function boot() {
    scan(document);
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Ceinture supplémentaire, jamais une dépendance :
  // bundle.main de Globo émet cet événement à chaque changement.
  ['gpoElementChanged'].forEach(function (name) {
    document.addEventListener(name, function () { scan(document); });
    window.addEventListener(name, function () { scan(document); });
  });

  // Bascule hover <-> tap : fermeture propre (même politique que
  // onMqChange dans globo.tooltip.js).
  function onMqChange() { closeNow(); }
  if (NO_HOVER_MQ.addEventListener) NO_HOVER_MQ.addEventListener('change', onMqChange);
  if (NARROW_MQ.addEventListener)   NARROW_MQ.addEventListener('change', onMqChange);
})();
